import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import { ConfigProvider } from 'antd'
import { StyleProvider } from '@ant-design/cssinjs'
import { AppErrorBoundary } from 'components/feedback/ErrorBoundary'
import './assets/layer-order.css'
import { antdTheme } from './assets/theme'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Router from './router'
import StylesLoader from './stylesLoader'
import * as serviceWorker from './serviceWorker'

// middlewared
const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware({
  onError: error => {
    console.error('Saga error:', error)
  },
})
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }
/**
 * Enable Redux DevTools in development only.
 * Falls back to plain `compose` in production — DevTools code is stripped from the bundle.
 * @see https://github.com/reduxjs/redux-devtools/tree/main/extension
 */
/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose
/* eslint-enable no-underscore-dangle */
const store = createStore(reducers(history), composeEnhancers(applyMiddleware(...middlewares)))

try {
  sagaMiddleware.run(sagas)
} catch (error) {
  console.error('Error starting sagas:', error)
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <StyleProvider layer>
      <ConfigProvider theme={antdTheme}>
        <StylesLoader />
        <AppErrorBoundary>
          <Router history={history} />
        </AppErrorBoundary>
      </ConfigProvider>
    </StyleProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
